import { Navigate } from "react-router-dom";
import { UserRole } from "../../users/enums";
import { useAuthUser } from "../hooks/useAuthUser";

export const Guest = ({ children }: { children: React.ReactElement }) => {
  const { initialized, user } = useAuthUser();

  // wait for store to initialize
  if (!initialized) {
    return null;
  }

  // Redirect both admin and user roles to the admin dashboard
  if (user && (user.role === UserRole.Admin || user.role === UserRole.User)) {
    return <Navigate to="/admin/surveys" />;
  }

  return <>{children}</>;
};
